// import React, { useState, useRef, useEffect } from "react";
// import "./selectedvalues.css";
// import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function SelectDropdown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   Height,
//   OverFlow,
//   minheight,
//   placeholder = "",
//   marginLeft,
//   marginTop,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState(""); // Track selected label for display
//   const dropdownRef = useRef(null);

//   // Update displayed label when the `selected` prop changes
//   useEffect(() => {
//     const selectedOption = options.find((option) => option.id === selected);
//     setSelectedLabel(selectedOption ? selectedOption.label : "");
//   }, [selected, options]);

//   // Close the dropdown when clicking outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Handle dropdown item click
//   const handleClick = (option) => {
//     setSelected(option.id); // Update the selected value in parent
//     setIsActive(false); // Close the dropdown
//     setSelectedLabel(option.label); // Update displayed label
//   };

//   return (
//     <div
//       className="dropdown"
//       style={{ width, marginLeft, marginTop }}
//       ref={dropdownRef}
//     >
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div
//         className="dropdown-btn"
//         onClick={() => setIsActive((prev) => !prev)}
//       >
//         {selectedLabel || placeholder}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: minheight,
//             height: Height,
//             overflow: OverFlow,
//           }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className={`dropdown-item ${option.id === selected ? "selected" : ""}`}
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }







import React, { useState, useRef, useEffect } from "react";
import "./selectedvalues.css";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function SelectDropdown({
  width,
  label,
  selected,
  setSelected,
  options = [],
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
  disabled = false, // added prop
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(""); // Track selected label for display
  const dropdownRef = useRef(null);

  // Update displayed label when the `selected` prop changes
  useEffect(() => {
    const selectedOption = options.find((option) => option.id === selected);
    setSelectedLabel(selectedOption ? selectedOption.label : "");
  }, [selected, options]);

  // Close the dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle dropdown item click
  const handleClick = (option) => {
    if (disabled) return; // ignore clicks when disabled
    setSelected(option.id); // Update the selected value in parent
    setIsActive(false); // Close the dropdown
    setSelectedLabel(option.label); // Update displayed label
  };

  const toggleActive = () => {
    if (disabled) return;
    setIsActive((prev) => !prev);
  };

  return (
    <div
      className="dropdown"
      style={{
        width,
        marginLeft,
        marginTop,
        // opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
      ref={dropdownRef}
      aria-disabled={disabled}
    >
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        className="dropdown-btn"
        onClick={toggleActive}
        style={{
          // backgroundColor: disabled ? "#f5f5f5" : "white",
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: "8px",
        }}
      >
        <span style={{ color: selectedLabel ? "#6A6A6A" : "#aaa" }}>
          {selectedLabel || placeholder}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <img src={DropDownIcon} alt="dropdown-icon" />
        </div>
      </div>
      {isActive && !disabled && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: minheight,
            height: Height,
            overflow: OverFlow,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className={`dropdown-item ${option.id === selected ? "selected" : ""}`}
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
